/**
 * @flow
 * @relayHash de84260e4b74d3ec0e149124fd101513
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ReleaseDeliverablesListHeader_release$ref = any;
type ReleaseDeliverablesList_release$ref = any;
type ReleaseDeliverablesList_stateTypes$ref = any;
export type ReleaseDeliverablesTabQueryVariables = {|
  id: string,
  first?: ?number,
  after?: ?string,
  orderBy?: ?string,
  dueDateFrom?: ?any,
  dueDateTo?: ?any,
  title?: ?string,
  includeInactive?: ?boolean,
  assignedToStaffOrContractor?: ?string,
  staffCoordinator?: ?string,
  state?: ?string,
  category?: ?string,
  tags?: ?string,
  includeClosed?: ?boolean,
  includeCanceled?: ?boolean,
|};
export type ReleaseDeliverablesTabQueryResponse = {|
  +release: ?{|
    +$fragmentRefs: ReleaseDeliverablesListHeader_release$ref & ReleaseDeliverablesList_release$ref
  |},
  +__type: ?{|
    +$fragmentRefs: ReleaseDeliverablesList_stateTypes$ref
  |},
|};
export type ReleaseDeliverablesTabQuery = {|
  variables: ReleaseDeliverablesTabQueryVariables,
  response: ReleaseDeliverablesTabQueryResponse,
|};
*/


/*
query ReleaseDeliverablesTabQuery(
  $id: ID!
  $first: Int
  $after: String
  $orderBy: String
  $dueDateFrom: Date
  $dueDateTo: Date
  $title: String
  $includeInactive: Boolean
  $assignedToStaffOrContractor: String
  $staffCoordinator: String
  $state: String
  $category: ID
  $tags: String
  $includeClosed: Boolean
  $includeCanceled: Boolean
) {
  release(id: $id) {
    ...ReleaseDeliverablesListHeader_release
    ...ReleaseDeliverablesList_release
    id
  }
  __type(name: "DeliverableState") {
    ...ReleaseDeliverablesList_stateTypes
  }
}

fragment ReleaseDeliverablesListHeader_release on ReleaseNode {
  id
  numberOfUnassignedDeliverables
  numberOfDeliverablesWithoutCoordinator
  deliverablesTotalAmount
  deliverablesTotalContractedAmount
}

fragment ReleaseDeliverablesList_release on ReleaseNode {
  id
  deliverables(first: $first, orderBy: $orderBy, after: $after, dueDateFrom: $dueDateFrom, dueDateTo: $dueDateTo, title: $title, state: $state, includeInactive: $includeInactive, category: $category, tags: $tags, includeClosed: $includeClosed, includeCanceled: $includeCanceled, staffCoordinator: $staffCoordinator, assignedToStaffOrContractor: $assignedToStaffOrContractor) {
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    totalCount
    edgeCount
    edges {
      cursor
      node {
        id
        jobId
        job {
          id
          name
        }
        title
        categoryType {
          name
          id
        }
        category {
          name
          id
        }
        state
        reviewStep
        amount
        currencyCode
        dueDate
        assignedContractor {
          id
          representativeImageUrl
          fullName
        }
        assignedInternally {
          id
          representativeImageUrl
          fullName
        }
        assignedStaff {
          user {
            id
          }
          fullName
          representativeImageUrl
          id
        }
      }
    }
  }
}

fragment ReleaseDeliverablesList_stateTypes on __Type {
  enumValues {
    name
    description
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "first",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "after",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "dueDateFrom",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "dueDateTo",
    "type": "Date",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "title",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includeInactive",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "assignedToStaffOrContractor",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "staffCoordinator",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "state",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "category",
    "type": "ID",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "tags",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includeClosed",
    "type": "Boolean",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "includeCanceled",
    "type": "Boolean",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "name",
    "value": "DeliverableState"
  }
],
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v5 = [
  (v4/*: any*/),
  (v3/*: any*/)
],
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "representativeImageUrl",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v8 = [
  (v3/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ReleaseDeliverablesTabQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "release",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ReleaseNode",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ReleaseDeliverablesListHeader_release",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "ReleaseDeliverablesList_release",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "__type",
        "storageKey": "__type(name:\"DeliverableState\")",
        "args": (v2/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "ReleaseDeliverablesList_stateTypes",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ReleaseDeliverablesTabQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "release",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ReleaseNode",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numberOfUnassignedDeliverables",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numberOfDeliverablesWithoutCoordinator",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "deliverablesTotalAmount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "deliverablesTotalContractedAmount",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "deliverables",
            "storageKey": null,
            "args": [
              {
                "kind": "Variable",
                "name": "after",
                "variableName": "after"
              },
              {
                "kind": "Variable",
                "name": "assignedToStaffOrContractor",
                "variableName": "assignedToStaffOrContractor"
              },
              {
                "kind": "Variable",
                "name": "category",
                "variableName": "category"
              },
              {
                "kind": "Variable",
                "name": "dueDateFrom",
                "variableName": "dueDateFrom"
              },
              {
                "kind": "Variable",
                "name": "dueDateTo",
                "variableName": "dueDateTo"
              },
              {
                "kind": "Variable",
                "name": "first",
                "variableName": "first"
              },
              {
                "kind": "Variable",
                "name": "includeCanceled",
                "variableName": "includeCanceled"
              },
              {
                "kind": "Variable",
                "name": "includeClosed",
                "variableName": "includeClosed"
              },
              {
                "kind": "Variable",
                "name": "includeInactive",
                "variableName": "includeInactive"
              },
              {
                "kind": "Variable",
                "name": "orderBy",
                "variableName": "orderBy"
              },
              {
                "kind": "Variable",
                "name": "staffCoordinator",
                "variableName": "staffCoordinator"
              },
              {
                "kind": "Variable",
                "name": "state",
                "variableName": "state"
              },
              {
                "kind": "Variable",
                "name": "tags",
                "variableName": "tags"
              },
              {
                "kind": "Variable",
                "name": "title",
                "variableName": "title"
              }
            ],
            "concreteType": "DeliverableNodeConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasPreviousPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "startCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "totalCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "edgeCount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "DeliverableNodeEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "DeliverableNode",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "jobId",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "job",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobNode",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "title",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "categoryType",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CategoryTypeNode",
                        "plural": false,
                        "selections": (v5/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "category",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "CategoryNode",
                        "plural": false,
                        "selections": (v5/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "state",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "reviewStep",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "amount",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "currencyCode",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "dueDate",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "assignedContractor",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ContractorNode",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "assignedInternally",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StaffNode",
                        "plural": false,
                        "selections": (v8/*: any*/)
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "assignedStaff",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "StaffNode",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "user",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "UserNode",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/)
                            ]
                          },
                          (v7/*: any*/),
                          (v6/*: any*/),
                          (v3/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "__type",
        "storageKey": "__type(name:\"DeliverableState\")",
        "args": (v2/*: any*/),
        "concreteType": "__Type",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "enumValues",
            "storageKey": null,
            "args": null,
            "concreteType": "__EnumValue",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "description",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ReleaseDeliverablesTabQuery",
    "id": null,
    "text": "query ReleaseDeliverablesTabQuery(\n  $id: ID!\n  $first: Int\n  $after: String\n  $orderBy: String\n  $dueDateFrom: Date\n  $dueDateTo: Date\n  $title: String\n  $includeInactive: Boolean\n  $assignedToStaffOrContractor: String\n  $staffCoordinator: String\n  $state: String\n  $category: ID\n  $tags: String\n  $includeClosed: Boolean\n  $includeCanceled: Boolean\n) {\n  release(id: $id) {\n    ...ReleaseDeliverablesListHeader_release\n    ...ReleaseDeliverablesList_release\n    id\n  }\n  __type(name: \"DeliverableState\") {\n    ...ReleaseDeliverablesList_stateTypes\n  }\n}\n\nfragment ReleaseDeliverablesListHeader_release on ReleaseNode {\n  id\n  numberOfUnassignedDeliverables\n  numberOfDeliverablesWithoutCoordinator\n  deliverablesTotalAmount\n  deliverablesTotalContractedAmount\n}\n\nfragment ReleaseDeliverablesList_release on ReleaseNode {\n  id\n  deliverables(first: $first, orderBy: $orderBy, after: $after, dueDateFrom: $dueDateFrom, dueDateTo: $dueDateTo, title: $title, state: $state, includeInactive: $includeInactive, category: $category, tags: $tags, includeClosed: $includeClosed, includeCanceled: $includeCanceled, staffCoordinator: $staffCoordinator, assignedToStaffOrContractor: $assignedToStaffOrContractor) {\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n    totalCount\n    edgeCount\n    edges {\n      cursor\n      node {\n        id\n        jobId\n        job {\n          id\n          name\n        }\n        title\n        categoryType {\n          name\n          id\n        }\n        category {\n          name\n          id\n        }\n        state\n        reviewStep\n        amount\n        currencyCode\n        dueDate\n        assignedContractor {\n          id\n          representativeImageUrl\n          fullName\n        }\n        assignedInternally {\n          id\n          representativeImageUrl\n          fullName\n        }\n        assignedStaff {\n          user {\n            id\n          }\n          fullName\n          representativeImageUrl\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ReleaseDeliverablesList_stateTypes on __Type {\n  enumValues {\n    name\n    description\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cf18e89cad5fd849449c6db69bd9fd76';
module.exports = node;
